
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "@sentry/ember/-embroider-implicit-modules.js";
import "@capital/object-factory/-embroider-implicit-modules.js";
import "@dashboard/user/-embroider-implicit-modules.js";
import "@square/experiments/-embroider-implicit-modules.js";
import "@dashboard/junk-drawer/-embroider-implicit-modules.js";
import "@dashboard/shared-ui/-embroider-implicit-modules.js";
import "@square/dashboard-protos/-embroider-implicit-modules.js";
import "@square/dashboard-utilities/-embroider-implicit-modules.js";
import "@square/ember-features/-embroider-implicit-modules.js";
import "@square/environment-utils/-embroider-implicit-modules.js";
